import React, { useRef, useState } from 'react';
import { useRouter } from 'next/navigation';
import { Lines } from '@/types';
import { CanvasDraw, ColorPicker, PencilColor } from '@/components';
import { WhitePanel } from './WhitePanel';
import { Toolbar } from './Toolbar';
import { ActivityStepSkeleton } from '../Activity';

interface MsPaintProps {
  canClose?: boolean;
}

export const MsPaint = ({ canClose = true }: MsPaintProps) => {
  const router = useRouter();
  const drawRef = useRef<CanvasDraw | null>(null);

  const [currentColor, setCurrentColor] = useState<PencilColor>(
    PencilColor.Red,
  );

  const [, setOutputLines] = useState<Lines>([]);

  return (
    <ActivityStepSkeleton
      identifier="ms-paint"
      ariaLabel="Drawing activity"
      stage="write"
    >
      <div className="relative rounded-xl py-6 sm:px-3 md:px-6 lg:px-12 bg-white shadow-md w-full h-full">
        <div className="flex flex-col gap-3 items-center text-center h-full">
          <Toolbar
            onRefresh={() => drawRef.current?.reset()}
            onClose={canClose ? () => router.push('/') : undefined}
          />

          <WhitePanel mode="basic" kind="fill" color="paper">
            <CanvasDraw
              ref={drawRef}
              currentColor={currentColor}
              setOutputLines={setOutputLines}
              fill
            />
          </WhitePanel>
        </div>
      </div>

      <ColorPicker
        className="absolute left-0 bottom-0 rounded-t-3xl bg-yellow-dark w-full h-28 px-2"
        currentColor={currentColor}
        setCurrentColor={setCurrentColor}
      />
    </ActivityStepSkeleton>
  );
};
